import { render, staticRenderFns } from "./wxAuthorzeUserInfoMask.vue?vue&type=template&id=2e440187&scoped=true"
import script from "./wxAuthorzeUserInfoMask.vue?vue&type=script&lang=js"
export * from "./wxAuthorzeUserInfoMask.vue?vue&type=script&lang=js"
import style0 from "./wxAuthorzeUserInfoMask.vue?vue&type=style&index=0&id=2e440187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e440187",
  null
  
)

export default component.exports